<template>
  <div class="hero-promo">{{ promoText }}</div>
</template>

<script>
export default {
  name: 'PromoBanner',
  computed: {
    promoText() {
      const locale = this.$i18n.locale;
      const tag = locale === 'ru' ? 'ru-RU' : locale === 'et' ? 'et-EE' : 'en-GB';
      const date = new Intl.DateTimeFormat(tag, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(new Date(2026, 11, 31));
      return this.$t('homeNew.hero.promo', { date });
    },
  },
};
</script>

<style scoped>
.hero-promo {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  padding: 20px 16px;
  text-transform: uppercase;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.3;
  text-align: center;
  text-wrap: balance;
  background: rgba(19, 22, 20, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  pointer-events: none;
  box-sizing: border-box;
}

@media screen and (min-width: 768px) {
  .hero-promo {
    padding: 22px 40px;
    font-size: 28px;
  }
}

@media screen and (min-width: 1024px) {
  .hero-promo {
    padding: 24px 40px;
    font-size: 32px;
  }
}

@media screen and (min-width: 1440px) {
  .hero-promo {
    padding: 24px 80px;
    font-size: 36px;
  }
}

@media screen and (min-width: 1920px) {
  .hero-promo {
    padding: 26px 120px;
    font-size: 40px;
  }
}
</style>
